import { jsx as C } from "react/jsx-runtime";
const l = ({
  width: o,
  height: t,
  className: n
}) => /* @__PURE__ */ C(
  "svg",
  {
    className: n,
    fill: "none",
    height: t,
    viewBox: "0 0 13 7",
    width: o,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M6.49943 4.88925L1.5835 0.255996C1.4975 0.174651 1.39528 0.110102 1.28272 0.0660586C1.17016 0.0220148 1.04946 -0.000658512 0.927571 -0.000658512C0.805679 -0.000658512 0.684988 0.0220148 0.572425 0.0660586C0.459862 0.110102 0.357643 0.174651 0.271641 0.255996C0.0980438 0.421165 0.000667572 0.64417 0.000667572 0.876563C0.000667572 1.10896 0.0980438 1.33196 0.271641 1.49713L5.84148 6.74809C6.01051 6.90684 6.23804 6.99811 6.47671 7.00291C6.71539 7.00771 6.94684 6.92568 7.12292 6.77386L12.7293 1.49999C12.8158 1.41888 12.8845 1.3225 12.9315 1.21637C12.9785 1.11024 13.0028 0.996437 13.0031 0.881453C13.0034 0.766469 12.9796 0.652558 12.9332 0.546225C12.8867 0.439891 12.8184 0.343217 12.7323 0.261723C12.6462 0.180229 12.5438 0.115511 12.4311 0.0712628C12.3184 0.0270146 12.1976 0.00410355 12.0755 0.00383759C11.9534 0.00357162 11.8324 0.0259568 11.7195 0.0697136C11.6066 0.11347 11.5039 0.177743 11.4174 0.258861L6.49943 4.88925Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  l as Content
};
